import template from './gtExercisesDistributionTemplate.html';
import controller from './gtExercisesDistributionController';

export default function ($stateProvider) {
    $stateProvider.state('stats2', {
        parent: 'ng-admin',
        url: '/stats/gt_exercise_distribution',
        params: { },
        controller: controller,
        template: template
    });
};



// WEBPACK FOOTER //
// ./js/stats/gtExercisesDistribution.js